import UsersSvg from "../../../public/assets/svg/users-svgrepo-com.svg";
import FeedbackSvg from "../../../public/assets/svg/feedback-svgrepo-com.svg";
import MailSvg from "../../../public/assets/svg/mail-svgrepo-com.svg";
import TemplateSvg from "../../../public/assets/svg/template-svgrepo-com.svg";
import HistorySvg from "../../../public/assets/svg/history-svgrepo-com.svg";
import SettingSvg from "../../../public/assets/svg/settings-2-svgrepo-com.svg";
import SettingOptionSvg from "../../../public/assets/svg/settings-menu-option.svg";
import KeySvg from "../../../public/assets/svg/key-svgrepo-com.svg";
import MonitorSvg from "../../../public/assets/svg/monitor-svgrepo-com.svg";
import ErrorSvg from "../../../public/assets/svg/error-16-svgrepo-com.svg";
import EventSvg from "../../../public/assets/svg/events-svgrepo-com.svg";
import SystemSvg from "../../../public/assets/svg/system-expired-line-svgrepo-com.svg";
import SystemSettingsSvg from "../../../public/assets/svg/settings-general.svg";
import SystemLogsSvg from "../../../public/assets/svg/code-tech-dev-svgrepo-com.svg";
import SystemUpdateSvg from "../../../public/assets/svg/update-svgrepo-com.svg";
import DashboardSvg from "../../../public/assets/svg/dashboard-svgrepo-com.svg";
import LanguagesSvg from "../../../public/assets/svg/languages-side-menu.svg";
import type { SvgIconProps } from "../types/svgIconComponsets";
//------------Template-----------------

import CoursesSvg from "../../../public/assets/svg/courses-svgrepo-com.svg";
import MessagesSvg from "../../../public/assets/svg/messages-menu.svg";
import OrdersSvg from "../../../public/assets/svg/orders-side-menu.svg";
import HomeSettingsSvg from "../../../public/assets/svg/menu-side-home-setting.svg";
import ContactsSettingsSvg from "../../../public/assets/svg/contacts-phone-mobile-svgrepo-com.svg";

export type MenuDesingModel = {
  href: string;
  icon: SvgIconProps;
  title: string;
};

type MenuSystemModel = {
  href?: string;
  icon: SvgIconProps;
  title: string;
  list?: MenuDesingModel[];
};

export const menuSystem: MenuSystemModel[] = [
  {
    href: "/dashboard",
    icon: DashboardSvg,
    title: "Дашборд",
  },
  {
    href: "/users",
    icon: UsersSvg,
    title: "Пользователи",
  },
  {
    href: "/courses",
    icon: CoursesSvg,
    title: "Курсы",
  },
  {
    href: "/messages",
    icon: MessagesSvg,
    title: "Сообщения (Чат)",
  },
  {
    href: "/orders",
    icon: OrdersSvg,
    title: "Заявки",
  },
  {
    href: "/feedbacks",
    icon: FeedbackSvg,
    title: "Обратная связь",
  },
  {
    href: "/content-record",
    icon: HomeSettingsSvg,
    title: "Настройка главной",
  },
  {
    href: "/contact-settings",
    icon: ContactsSettingsSvg,
    title: "Контакты",
  },
  {
    icon: MailSvg,
    title: "Почта",
    list: [
      {
        href: "/email-history",
        icon: HistorySvg,
        title: "История",
      },
      {
        href: "/email-templates",
        icon: TemplateSvg,
        title: "Шаблоны",
      },
      {
        href: "/email/smtp",
        icon: SettingOptionSvg,
        title: "SMTP",
      },
    ],
  },
  {
    icon: SettingSvg,
    title: "Настройки",
    list: [
      {
        href: "/language/list",
        icon: LanguagesSvg,
        title: "Языки",
      },
      {
        href: "/configuration/keys",
        icon: KeySvg,
        title: "Конфигуратор ключей",
      },
      {
        href: "/settings",
        icon: SettingOptionSvg,
        title: "Настройки",
      },
    ],
  },
  {
    icon: MonitorSvg,
    title: "Работа приложения",
    list: [
      {
        href: "/app-logs",
        icon: ErrorSvg,
        title: "Логи приложения",
      },
      {
        href: "/logs",
        icon: SystemLogsSvg,
        title: "Все логи",
      },
      {
        href: "/events",
        icon: EventSvg,
        title: "События",
      },
    ],
  },
  {
    icon: SystemSvg,
    title: "Система",
    list: [
      {
        href: "/common-settings",
        icon: SystemSettingsSvg,
        title: "Общие настройки",
      },
      {
        href: "/update-system",
        icon: SystemUpdateSvg,
        title: "Обновление системы",
      },
    ],
  },
];
